/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as React from 'react';
import { GlobalState } from '../../../actions';
import { connect } from 'react-redux';
import { playlistSearchFromDate, playlistSearchToDate } from '../selectors';
import { DateTimeEdit } from '../../../common/DateTimeEdit';
import { searchPlaylist, setPlaylistFromDate, setPlaylistToDate } from '../actions';
import { Dispatch } from 'redux';

interface PlaylistSearchTimeFrameProps {
    fromDateTime: Date;
    toDateTime: Date;

    onFromDateChange: (d: Date) => void;
    onToDateChange: (d: Date) => void;
}

class PlaylistSearchTimeFrame extends React.Component<PlaylistSearchTimeFrameProps> {

    render() {
        return (
            <div>
                <DateTimeEdit date={this.props.fromDateTime} onChange={this.props.onFromDateChange}/>
                <DateTimeEdit date={this.props.toDateTime} onChange={this.props.onToDateChange}/>
            </div>
        );
    }

}

const mapStateToProps = (state: GlobalState) => {
    return {
        fromDateTime: playlistSearchFromDate(state),
        toDateTime: playlistSearchToDate(state)
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        onFromDateChange: (d: Date) => {
            console.info('from Date changed: ' + d);
            dispatch(setPlaylistFromDate(d));
            dispatch(searchPlaylist());
        },
        onToDateChange: (d: Date) => {
            console.info('to Date changed: ' + d);
            dispatch(setPlaylistToDate(d));
            dispatch(searchPlaylist());
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistSearchTimeFrame);